<template>
  <div class="coin-trend">
    <!-- <van-nav-bar title="纪念币实时走势" left-arrow @click-left="onClickLeft" /> -->

    <!-- 热门品种实时行情入口 -->
    <div class="hot-entry" @click="openHotPopup">
      <div class="entry-content">
        <span class="entry-text">热门品种实时行情</span>
        <van-icon name="arrow-down" />
      </div>
    </div>

    <!-- 图表展示区域 -->
    <div v-if="selectedBreed" class="chart-container">
      <coin-chart :breed-item="selectedBreed" :section-code="sectionCode" />
    </div>

    <!-- 空状态 -->
    <div v-else class="empty-state">
      <van-empty description="请选择热门品种查看行情" />
    </div>

    <!-- 热门品种弹窗 -->
    <hot-charts-popup
      ref="hotPopup"
      :list="breedList"
      :selected-breed="selectedBreed"
      @handleBreed="handleBreedSelect"
    />
  </div>
</template>

<script>
import HotChartsPopup from './HotChartsPopup.vue';
import CoinChart from './CoinChart.vue';
import { queryPannel } from '@/api/base';

export default {
  name: 'CoinTrend',
  components: {
    HotChartsPopup,
    CoinChart,
  },
  data() {
    return {
      breedList: [],
      selectedBreed: null,
      sectionCode: 'coin',
    };
  },
  created() {
    this.loadBreedList();
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    async loadBreedList() {
      try {
        const res = await queryPannel({
          filters: {},
          themeEn: 'post',
          sceneEn: 'getAllPanDataBreed',
        });
        if (res.code === 0 && res.data && res.data.body) {
          this.breedList = res.data.body;
          // 默认选择第一个品种
          if (this.breedList.length > 0) {
            this.selectedBreed = this.breedList[0];
          }
        }
      } catch (error) {
        console.error('加载热门品种失败:', error);
        this.$toast('加载热门品种失败');
      }
    },
    openHotPopup() {
      if (this.breedList.length === 0) {
        this.$toast('暂无热门品种数据');
        return;
      }
      this.$refs.hotPopup.open();
    },
    handleBreedSelect(breed) {
      this.selectedBreed = breed;
    },
  },
};
</script>

<style scoped lang="less">
.coin-trend {
  min-height: 100vh;
  background-color: #f7f8fa;
}

.hot-entry {
  background: #fff;
  padding: 15px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:active {
    background-color: #f7f8fa;
  }

  .entry-content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .entry-text {
      font-size: 16px;
      font-weight: 500;
      color: #323233;
    }
  }
}

.chart-container {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.empty-state {
  padding: 60px 20px;
}

.trend-container {
  padding-top: 46px;
}

.chart-wrapper {
  background: #fff;
  padding: 20px;
  margin-bottom: 10px;
}

.chart-placeholder {
  height: 300px;
  border: 2px dashed #dcdee0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #969799;

  p {
    margin: 5px 0;
  }

  .chart-desc {
    font-size: 12px;
  }
}

.coin-info {
  margin-top: 10px;
}

.price {
  font-weight: bold;
  font-size: 16px;

  &.up {
    color: #ee0a24;
  }

  &.down {
    color: #07c160;
  }
}
</style>
